import { createStore } from 'effector';
import { type PayoutTraderFilters } from '~/entities/payout';
import { setTradersFilter } from './event';

export const $tradersFilter = createStore<PayoutTraderFilters>({}).on(setTradersFilter, (src, payload) => ({
    ...src,
    ...payload,
}));
